import React from 'react';
import { Search, Users, Upload, Settings, PieChart, FileSearch, Briefcase, Shield } from 'lucide-react';
import clsx from 'clsx';






export default function Sidebar({ activeTab, setActiveTab, user }) { // Accept user prop
    // Removed internal state and useEffect
    // const [user, setUser] = useState(null); 

    const displayName = user && user.name ? user.name : (user && user.email ? user.email.split('@')[0].replace(/[._]/g, ' ') : "Loading...");
    // Fallback logic for initials
    const initials = displayName !== "Loading..." ? displayName.substring(0, 2).toUpperCase() : "..";

    const menuItems = [
        { id: 'discover', label: 'Discover', icon: Search },
        { id: 'jobs', label: 'Jobs', icon: Briefcase },
        { id: 'vault', label: 'Talent Vault', icon: Users },
        { id: 'import', label: 'Import', icon: Upload },
        { id: 'insights', label: 'Insights', icon: PieChart },
        { id: 'settings', label: 'Settings', icon: Settings },
    ];

    if (user?.role === 'admin') {
        const hasAdmin = menuItems.find(i => i.id === 'admin');
        if (!hasAdmin) {
            menuItems.push({ id: 'admin', label: 'Admin Panel', icon: Shield });
        }
    }

    return (
        <div className="hidden lg:flex flex-col w-64 h-screen fixed left-0 top-0 bg-white border-r border-slate-200 dark:bg-slate-900 dark:border-slate-800 transition-colors z-50">

            {/* Brand */}
            <div className="h-16 flex items-center px-6 border-b border-slate-100 dark:border-slate-800">
                <div className="bg-brand-600 p-1.5 rounded-lg text-white mr-3 shadow-md shadow-brand-200 dark:shadow-none">
                    <FileSearch className="w-5 h-5" />
                </div>
                <span className="text-lg font-bold bg-clip-text text-transparent bg-gradient-to-r from-brand-700 to-brand-500 dark:from-brand-400 dark:to-brand-200">
                    Resume <span className="text-slate-700 dark:text-slate-300">Helper</span>
                </span>
            </div>

            {/* Menu */}
            <nav className="flex-1 py-6 px-3 space-y-1">
                {menuItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeTab === item.id;
                    const isAdminItem = item.id === 'admin';

                    return (
                        <button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            className={clsx(
                                "w-full flex items-center px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 group",
                                isActive
                                    ? (isAdminItem
                                        ? "bg-purple-50 text-purple-700 dark:bg-purple-900/20 dark:text-purple-300"
                                        : "bg-brand-50 text-brand-700 dark:bg-brand-900/20 dark:text-brand-300")
                                    : "text-slate-600 hover:bg-slate-50 dark:text-slate-400 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200"
                            )}
                        >
                            <Icon className={clsx(
                                "w-5 h-5 mr-3 transition-colors",
                                isActive
                                    ? (isAdminItem ? "text-purple-600 dark:text-purple-400" : "text-brand-600 dark:text-brand-400")
                                    : "text-slate-400 group-hover:text-slate-600 dark:text-slate-500 dark:group-hover:text-slate-300"
                            )} />
                            {item.label}
                        </button>
                    );
                })}
            </nav>

            {/* Footer / User Profile Stub */}
            <div className="p-4 border-t border-slate-100 dark:border-slate-800">
                <button
                    onClick={() => setActiveTab('profile')}
                    className={clsx(
                        "w-full flex items-center gap-3 p-2 rounded-xl transition-colors text-left",
                        activeTab === 'profile'
                            ? "bg-brand-50 dark:bg-brand-900/20 border border-brand-100 dark:border-brand-900/30"
                            : "bg-slate-50 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700/80"
                    )}
                >
                    <div className="w-8 h-8 rounded-full bg-brand-200 flex items-center justify-center text-brand-700 font-bold text-xs">
                        {initials}
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className={clsx(
                            "text-xs font-semibold truncate capitalize",
                            activeTab === 'profile' ? "text-brand-700 dark:text-brand-300" : "text-slate-700 dark:text-slate-200"
                        )}>
                            {displayName}
                        </p>
                        <p className="text-[10px] text-slate-400 truncate">{user ? user.email : "Sign in..."}</p>
                    </div>
                </button>
            </div>
        </div>
    );
}
